var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridIcon = function SvgGridIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4h4V0H0zm6 12h4v-4H6zm-2 0H0v-4h4zm-4-6h4V6H0zm10 0H6V6h4zm2-10v4h4V0zm-2 4H6V0h4zm2 6h4V6h-4zm4 6h-4v-4h4z",
    clipRule: "evenodd"
  })));
};
export default SvgGridIcon;